import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Dropdown2.css';

const Dropdown2 = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  return (
    <ul onClick={handleClick} className={click ? 'dropdown-menu clicked' : 'dropdown-menu'}>
      <li key="pakiety">
        <NavLink
          to="/pakiety"
          className="dropdown-link"
          activeclassname="active"
          onClick={() => setClick(false)}
        >
          Pakiety ceremonii
        </NavLink>
      </li>
      <li key="coach">
        <NavLink
          to="/wsparcie"
          className="dropdown-link"
          activeclassname="active"
          onClick={() => setClick(false)}
        >
          Wsparcie
        </NavLink>
      </li>
      <li key="konsult">
        <NavLink
          to="/konsultacje"
          className="dropdown-link"
          activeclassname="active"
          onClick={() => setClick(false)}
        >
          Konsultacje projektowe
        </NavLink>
      </li>
      <li key="edukacja">
        <NavLink
          to="/edukacja"
          className="dropdown-link"
          activeclassname="active"
          onClick={() => setClick(false)}
        >
          Edukacja
        </NavLink>
      </li>
      <li key="bizuteria">
        <NavLink
          to="/bizuteria"
          className="dropdown-link"
          activeclassname="active"
          onClick={() => setClick(false)}
        >
          Biżuteria
        </NavLink>
      </li>
      <li key="livingfunerals">
  <NavLink
    to="/ceremonie#living"
    className={({ isActive }) =>
      isActive && window.location.hash !== "" ? "dropdown-link active" : "dropdown-link"
    }
    onClick={() => setClick(false)}
  >
    Living Funerals
  </NavLink>
</li>

<li key="wieczory">
  <NavLink
    to="/ceremonie#wieczory"
    className={({ isActive }) =>
      isActive && window.location.hash !== "" ? "dropdown-link active" : "dropdown-link"
    }
    onClick={() => setClick(false)}
  >
    Wieczory Pamięci
  </NavLink>
</li>

<li key="pozeganiepupila">
  <NavLink
    to="/ceremonie#pupil"
    className={({ isActive }) =>
      isActive && window.location.hash !== "" ? "dropdown-link active" : "dropdown-link"
    }
    onClick={() => setClick(false)}
  >
    Pożeganie Pupila
  </NavLink>
</li>

<li key="pamiecizycia">
  <NavLink
    to="/ceremonie#pamieci"
    className={({ isActive }) =>
      isActive && window.location.hash !== "" ? "dropdown-link active" : "dropdown-link"
    }
    onClick={() => setClick(false)}
  >
    Ceremonie Pamięci Życia
  </NavLink>
</li>
    </ul>
  );
};

export default Dropdown2;